const getters = {
  token: state => state.user.token,
  userInfo: state => state.user.userInfo,
  permissions: state => state.user.permissions,

  deptData: state => state.dept.deptData,
  deptMapOfIdsArray: state => state.dept.deptMapOfIdsArray,

  goodsVer: state => state.goods.goodsVer, // 产品缓存版本
  goodsData: state => state.goods.goodsData, // 带产品的cascade格式数据集
  goodsDataForSales: state => state.goods.goodsDataForSales, // 带产品的cascade格式数据集（只对外销售）
  goodsTypeList: state => state.goods.goodsTypeList, // 产品类型列表
  goodsTypeListForSales: state => state.goods.goodsTypeListForSales, // 产品类型列表（只对外销售）
  goodsMapOfIdsArray: state => state.goods.goodsMapOfIdsArray, // 可按产品ID检索对应的idsArray（产品类型+产品ID的cascade数组数据格式）
  goodsMapOfNamesArray: state => state.goods.goodsMapOfNamesArray, // 可按产品ID检索对应的namesArray（产品名称的cascade数组数据格式）
  goodsMapOfId: state => state.goods.goodsMapOfId, // 可按产品ID检索对应的产品对象

  storageList: state => state.storage.storageList, // 普通库房列表
  storageFullList: state => state.storage.storageFullList, // 全部库房列表
  payTypeList: state => state.dict.payTypeList, // 支付方式（销售单）
  payTypeOfCompanyList: state => state.dict.payTypeOfCompanyList, // 支付方式（付款单）
  payAgreedList: state => state.dict.payAgreedList, // 支付约定
  expressDeliveryList: state => state.dict.expressDeliveryList, // 配送方式

  tips: state => state.tip.tips // 消息提示列表
}
export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js